/**
 * index.js
 *
 * @Author: jruif
 * @Date: 2017/7/10 下午10:52
 */

import Modal from './Modal';
import confirm from './Confirm';

export { Modal, confirm };
export default Modal;



// WEBPACK FOOTER //
// ./src/modal/index.js